import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule, SwRegistrationOptions } from '@angular/service-worker';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { SpotlightModule } from './features/spotlight/spotlight.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { WINDOW_PROVIDERS } from './core/providers/window.provider';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { DatePipe } from '@angular/common';

import { LineupModule } from './features/spotlight/lineup/lineup.module';
import { UpcomingModule } from './features/spotlight/upcoming/upcoming.module';
import { ImageCropperModule } from 'ngx-image-cropper';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PremiereDetailsModule } from './features/spotlight/premiere-details/premiere-details.module';
import { RedCarpetModule } from './features/spotlight/red-carpet/red-carpet.module';
import { TheaterModule } from './features/theater/theater.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PassportModule } from './features/passport/passport.module';
import { CinejoyModule } from './features/cinejoy/cinejoy.module';
import { ScreeningPartiesModule } from './features/screening-parties/screening-parties.module';
import { ShowcaseModule } from './features/showcase/showcase.module';
import { IAmVideoModule } from './features/creatics/i-am-video/i-am-video.module';
import { GroupSharingModule } from './features/group-sharing/group-sharing.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { SocialLoginModule, SocialAuthServiceConfig } from "angularx-social-login";
import { GoogleLoginProvider } from "angularx-social-login";

import { CarouselModule } from 'ngx-owl-carousel-o';
import { OnboardingModule } from './features/onboarding/onboarding.module';
import { HitmakerModule } from './features/creatics/hitmaker/hitmaker.module';
import { ContestanddrawingModule } from './features/creatics/contest and drawings/contestanddrawing.module';



@NgModule({
  declarations: [
    AppComponent,

  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    OnboardingModule,
    CoreModule,
    GroupSharingModule,
    SpotlightModule,
    RedCarpetModule,
    FormsModule,
    ReactiveFormsModule,
    UpcomingModule,
    LineupModule,
    PremiereDetailsModule,
    TheaterModule,
    ImageCropperModule,
    NgbModule,
    PassportModule,
    CommonModule,
    CinejoyModule,
    ShowcaseModule,
    HttpClientModule,
    ScreeningPartiesModule,
    IAmVideoModule,
    HttpClientModule,
    ScreeningPartiesModule,
    IAmVideoModule,
    CarouselModule,
    SocialLoginModule,
   HitmakerModule,
   ContestanddrawingModule,
    ServiceWorkerModule.register('./ngsw-worker.js', {
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })

  ],
  providers: [WINDOW_PROVIDERS,
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptcha.siteKey,
        type: 'image',
        size: 'normal',
        theme: 'light',
        badge: 'bottomright'
      } as RecaptchaSettings,
    },
    {
      provide: "SocialAuthServiceConfig",
      useValue: {
        autoLogin: true,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              '865704442149-qfp3imnuh8guu8o1avt56p2qtb37bnlg.apps.googleusercontent.com'
            )
          }
        ]
      } as SocialAuthServiceConfig
    },
    {
      provide: SwRegistrationOptions,
      useFactory: () => ({ enabled: environment.production }),
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
